export const DeepDiveConstants = {
  GET_DEEP_DIVE_DATA_REQUEST: 'DEEPDIVE/GET_DEEP_DIVE_DATA_REQUEST',
  GET_DEEP_DIVE_DATA_SUCCESS: 'DEEPDIVE/GET_DEEP_DIVE_DATA_SUCCESS',
  GET_DEEP_DIVE_DATA_FAILED: 'DEEPDIVE/GET_DEEP_DIVE_DATA_FAILED',

  GET_DEEP_DIVE_TABS_REQUEST: 'DEEPDIVE/GET_DEEP_DIVE_TABS_REQUEST',
  GET_DEEP_DIVE_TABS_SUCCESS: 'DEEPDIVE/GET_DEEP_DIVE_TABS_SUCCESS',
  GET_DEEP_DIVE_TABS_FAILED: 'DEEPDIVE/GET_DEEP_DIVE_TABS_FAILED',

  GET_METRIC_LIST_REQUEST: 'DEEPDIVE/GET_METRIC_LIST_REQUEST',
  GET_METRIC_LIST_SUCCESS: 'DEEPDIVE/GET_METRIC_LIST_SUCCESS',
  GET_METRIC_LIST_FAILED: 'DEEPDIVE/GET_METRIC_LIST_FAILED',

  GET_STORESC_CAMPAIGN_DROPDOWN_REQUEST: 'DEEPDIVE/GET_STORESC_CAMPAIGN_DROPDOWN_REQUEST',
  GET_STORESC_CAMPAIGN_DROPDOWN_SUCCESS: 'DEEPDIVE/GET_STORESC_CAMPAIGN_DROPDOWN_SUCCESS',
  GET_STORESC_CAMPAIGN_DROPDOWN_FAILED: 'DEEPDIVE/GET_STORESC_CAMPAIGN_DROPDOWN_FAILED',

  GET_PRODUCT_DROPDOWN_REQUEST: 'DEEPDIVE/GET_PRODUCT_DROPDOWN_REQUEST',
  GET_PRODUCT_DROPDOWN_SUCCESS: 'DEEPDIVE/GET_PRODUCT_DROPDOWN_SUCCESS',
  GET_PRODUCT_DROPDOWN_FAILED: 'DEEPDIVE/GET_PRODUCT_DROPDOWN_FAILED',

  GET_ADS_DATA: 'DEEPDIVE/GET_ADS_DATA',
  GET_KEYWORDS_DATA: 'DEEPDIVE/GET_KEYWORDS_DATA',
  GET_KEYWORDS_CHILD_TABLE_DATA: 'DEEPDIVE/GET_KEYWORDS_CHILD_TABLE_DATA',
  GET_CREATIVES_DATA: 'DEEPDIVE/GET_CREATIVES_DATA',
  GET_STORES_DATA: 'DEEPDIVE/GET_STORES_DATA',
  GET_STORES_CHILD_TABLE_DATA: 'DEEPDIVE/GET_STORES_CHILD_TABLE_DATA',
  GET_MEDIA_CHANNELS_DATA: 'DEEPDIVE/GET_MEDIA_CHANNELS_DATA',
  GET_MEDIA_CHANNELS_CHILD_TABLE_DATA: 'DEEPDIVE/GET_MEDIA_CHANNELS_CHILD_TABLE_DATA',

  GET_PRODUCT_TABLE_DATA: 'DEEPDIVE/GET_PRODUCT_TABLE_DATA',
  GET_PRODUCT_CHILD_TABLE_DATA: 'DEEPDIVE/GET_PRODUCT_CHILD_TABLE_DATA',

  GET_DEEP_DIVE_UPDATED_DATA: 'DEEPDIVE/GET_DEEP_DIVE_UPDATED_DATA',

  GET_CHANNEL_LIST: 'DEEPDIVE/GET_CHANNEL_LIST',
  GET_CHILD_TABLE_TOP_RECORD: 'DEEPDIVE/GET_CHILD_TABLE_TOP_RECORD',

  UPDATE_FILTER_GROUP: 'DEEPDIVE/UPDATE_FILTER_GROUP',

  UPDATE_ENTIRE_FILTER: 'DEEPDIVE/UPDATE_ENTIRE_FILTER',
  UPDATE_TEST: 'DEEPDIVE/UPDATE_TEST',
  UPDATE_ANY: 'DEEPDIVE/UPDATE_ANY',
  UPDATE_TAB: 'DEEPDIVE/UPDATE_TAB',
  UPDATE_STORE_GROUPS: 'DEEPDIVE/UPDATE_STORE_GROUPS',
  ACTIVE_TAB_ID_UPDATE: 'DEEPDIVE/ACTIVE_TAB_ID_UPDATE',
  UPDATE_SELECTED_STORES: 'DEEPDIVE/UPDATE_SELECTED_STORES',
  CHANGE_VIEW: 'DEEPDIVE/CHANGE_VIEW',
  GET_METRIC_DEFINITION_REQUEST: 'GET_METRIC_DEFINITION_REQUEST',
  GET_METRIC_DEFINITION_SUCCESS: 'DEEPDIVE/GET_METRIC_DEFINITION_SUCCESS',
  GET_METRIC_DEFINITION_FAILED: 'DEEPDIVE/GET_METRIC_DEFINITION_FAILED',

  GET_PREFERRED_COLUMN_REQUEST: 'DEEPDIVE/GET_PREFERRED_COLUMN_REQUEST',
  GET_PREFERRED_COLUMN_SUCCESS: 'DEEPDIVE/GET_PREFERRED_COLUMN_SUCCESS',
  GET_PREFERRED_COLUMN_FAILED: 'DEEPDIVE/GET_PREFERRED_COLUMN_FAILED',
  CURRENT_TABS:'DEEPDIVE/CURRENT_TABS',
};
